import React from 'react';

function FinishPage() {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="bg-white border border-gray-300 p-4 max-w-3xl w-full">
        <h1 className="text-2xl text-gray-800 font-bold m-2 text-center">
          Experiment Completed
        </h1>
        <p className="text-gray-800 text-center">
          Thank you for participating in the experiment. Your responses have been recorded.
        </p>
      </div>
    </div>
  );
}

export default FinishPage;
